import { useCallback } from 'react'

import useTracker from 'Pods/Shared/Hooks/useTracker'

const PAGE_TYPE = 'extra_usage_checkout'

const SDK_METHOD_MAP = {
  googlePay: 'google_pay',
  applePay: 'apple_pay',
}

export default function useExtraUsageCheckoutTracking() {
  const { trackEvent } = useTracker()

  const trackView = useCallback(() => {
    trackEvent('extra_usage_checkout_viewed', { page_type: PAGE_TYPE })
  }, [trackEvent])

  const trackPayClick = useCallback(() => {
    trackEvent('extra_usage_checkout_pay_click', { page_type: PAGE_TYPE })
  }, [trackEvent])

  const trackSuccess = useCallback(() => {
    trackEvent('extra_usage_checkout_payment_success', { page_type: PAGE_TYPE })
  }, [trackEvent])

  const trackPaymentMethodSelection = useCallback((method) => {
    trackEvent('extra_usage_checkout_payment_method_selected', {
      method: SDK_METHOD_MAP[method] || method,
      page_type: PAGE_TYPE,
    })
  }, [trackEvent])

  const trackFailure = useCallback((errorMessage) => {
    trackEvent('extra_usage_checkout_payment_failure', {
      page_type: PAGE_TYPE,
      error_message: errorMessage,
    })
  }, [trackEvent])

  return {
    trackView,
    trackPayClick,
    trackSuccess,
    trackPaymentMethodSelection,
    trackFailure,
  }
}
